import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const MailImg = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../../../images/icons/btn_mail.png"
      alt="mándanos un mail"
    />
  );
};

export default MailImg;
